<template>
  <ui-popover trigger="hover" :class="{disabled}" :disabled="disabled">
    <template #target>
      <a class="target-link" :href="link ? link : '#'">
        <div class="target-name">
          <div class="name">{{name}}</div>
          <div class="group">{{group}}</div>
        </div>
        <div>
          <ui-image :src="img" :alt="name" :default-src="defaultImage" design="circle" h="25" w="25" />
        </div>
      </a>
    </template>

    <template #content>
      <div class="card">
        <div class="coll-1">
          <ui-image
            :src="img"
            :alt="name"
            :default-src="defaultImage"
            design="circle"
            h="57"
            w="57"
          />
        </div>
        <div class="coll-2">
          <div class="info-container">
            <div class="name" v-if="name">{{name}}</div>
            <div class="location" v-if="team">{{team}}</div>
            <div class="role" v-if="group">
              <div class="tag">
                {{group}}
              </div>            
            </div>
          </div>
        </div>
      </div>
    </template>

    <template #footer>
      <div class="card-footer">
        <div class="footer">
          <div>
            <ui-tag-icon
              v-if="phone"
              :icon-size="14"
              :text-size="12"
              iconColor="#677286"
              color="#677286"
              :border="0"
              :text="phone"
              icon="fab fa-whatsapp"
            />
          </div>
          <div>
            <ui-tag-icon
              v-if="email"
              :icon-size="14"
              :text-size="12"
              iconColor="#677286"
              color="#677286"
              :border="0"
              :text="email"
              icon="fal fa-envelope-open-text"
            />
          </div>
        </div>
      </div>
    </template>
  </ui-popover>
</template>

<script>
import { uiImage, uiPopover } from "@/components/ui";
import { uiTagIcon } from "@/components/ui/tags";
import userImage from "@/assets/imgs/no-avatar.png"

export default {
  props: {
    data: {
      type: Object,
    },
    name: {
      required: false
    },
    team: {
      required: false
    },
    group: {
      required: false
    },
    email: {
      required: false
    },
    phone: {
      required: false
    },
    showImage: {
      type: Boolean,
      required: false,
      default: false
    },
    img: {
      type: String,
      required: false,
      default: userImage
    },
    link: {
      type: String,
      required: false
    },
    /**
     * Define o estado desativo do popover
     * apenas mostra os conteudos iniciais e desativa o trigger
     */
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  components: {
    uiImage,
    uiPopover,
    uiTagIcon,
  },

  data() {
    return {
      productCardContent: false,
    };
  },

  computed: {
    defaultImage(){
      return userImage
    }
  },

  methods: {
    showProductCardContent() {
      this.productCardContent = !this.productCardContent;
    },
  },
};
</script>

<style lang="stylus" scoped>
@import './styles.styl';
</style>